import { adminApi } from '../../../../store/generated/admin/survey_question';

export const SurveyQuestionApiTags = {
  SurveyQuestions: 'SurveyQuestions',
  SurveyQuestion: 'SurveyQuestion',
};

const taggedApi = adminApi.enhanceEndpoints({ addTagTypes: Object.values(SurveyQuestionApiTags) });

export const surveyQuestionApi = taggedApi.enhanceEndpoints({
  addTagTypes: [SurveyQuestionApiTags.SurveyQuestions],
  endpoints: {
    apiAdminV1SurveyQuestionCreate: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestions],
    },
    apiAdminV1SurveyQuestionList: {
      providesTags: [SurveyQuestionApiTags.SurveyQuestions],
    },
    apiAdminV1SurveyQuestionRetrieve: {
      providesTags: [SurveyQuestionApiTags.SurveyQuestions],
    },
    apiAdminV1SurveyQuestionUpdate: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestions],
    },
    apiAdminV1SurveyQuestionDestroy: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestions],
    },
  },
});

export enum SurveyType {
  EDI = 7,
  Outcomes = 10,
}